<template>
  <v-container class="stockli__full-width-container robins-egg-bkgr">
    <v-row class="mt-6">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3" class="mx-auto">
        <v-form ref="form" @submit.prevent="Login" class="mb-12">
          <img src="@/styles/assets/stockli-logo-white.png" class="stockli__login-logo" alt="Stockli, the Swiss Ski" />
          <div class="h2 text-center white-text mb-8">Indicator Setting Calculator &amp; Customer Data Application</div>
          <v-card class="stockli__login-form">
            <div class="h3 tac pa-6 uppercase bold">Login</div>
            <v-card-text>
              <v-text-field v-model="email" prepend-icon="mdi-account" label="Email" type="email" autofocus :rules="[ruleRequired, ruleEmail]" />
              <v-text-field v-model="password" prepend-icon="mdi-lock" label="Password" type="password" :rules="[ruleRequired]" />
              
              <v-alert v-if="submitError" type="error" class="mt-8">{{ submitError }}</v-alert>
            </v-card-text>
            <v-card-actions class="justify-center pb-8">
              <v-btn type="submit" :loading="submitting" :disabled="submitting" class="btn">Submit</v-btn>
            </v-card-actions>
            <div class="text-center py-6 small-text">
              <router-link text to="/forgot">Forgot Password</router-link>
            </div>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from "@/services/api";

export default {
  name: "Login",
  components: {
  },
  data: () => ({
    email: "",
    password: "",
    submitting: false,
    submitError: null,

    ruleRequired: v => !!v || "This field is required",
    ruleEmail: v => /.+@.+\..+/.test(v) || "Valid email required",
  }),
  methods: {
    async Login() {
      if (!this.$refs.form.validate()) return;

      this.submitting = true;
      this.submitError = null;
      try {
        await API.Login(this.email, this.password);
        this.$router.push("/location");
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.submitError = err.response.data.message;
        } else {
          this.submitError = "Unable to log in";
        }
      } finally {
        this.submitting = false;
      }
    },
  }
}
</script>
<style scoped lang="scss">
.stockli__login-container {
  height: 100vh;
}

.stockli__login-logo {
  display: block;
  width: 60%;
  max-width: 300px;
  height: auto;
  margin: 0 auto 2rem;
}

.stockli__login-form {
  width: 80%;
  max-width: 400px;
  margin: auto;
  box-shadow: none;
}
</style>
